import React from "react";
import { Route, Redirect } from "react-router-dom";
import auth from "../services/authService";

const ProtectedRoute = ({component: Component, render, ...rest}) => {
    const currentUser = auth.getCurrentUser();
    if (!currentUser) {
        return (
            <Redirect
                to={{
                    pathname: "/login",
                    state: {from: rest.location},
                }}
            />
        );
    }
    return (
        <Route
            {...rest}
            render={(props) => (Component ? <Component {...props} /> : render(props))}
        />
    );
};

ProtectedRoute.propTypes = {};

export default ProtectedRoute;
